module.exports = {
      id: "biggan-chinta-usage",
      viewBox: "0 0 156 40",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#biggan-chinta",
      toString: function () {
        return this.url;
      }
    }